import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';

import imageIcon from '@ckeditor/ckeditor5-core/theme/icons/image.svg';
import selected from './selected';
import translations from './lang/translations';
export default class InsertImage extends Plugin {
    init() {
        translations();
        const editor = this.editor;
        const { t } = editor.locale;
        
        let selectedItems = [];
        editor.ui.componentFactory.add( 'insertImage', locale => {
            const view = new ButtonView( locale );

            view.set( {
                label: t('Insert image'),
                icon: imageIcon,
                tooltip: true
            } );

            // Callback executed once the image is clicked.
            view.on( 'execute', () => {
                $.ajax({
                    url: '/admin/media/internal',
                    type: 'post',
                    data: {
                        type: 'Groups',
                        id: 'internal',
                    },
                    success: function(response){ 
                      // Add response in Modal body
                      sessionStorage.setItem('background_image', 'false');
                      let modalContent = document.createElement('div');
                      modalContent.classList.add('image-picker-container');
                      if(response.length == 0){
                          modalContent.innerText = t('Internal media storage is empty.');
                      }
                      for (let i=0; i<response.length; i++){
                          let container = document.createElement('div');
                          container.classList.add('image-picker-item');
                          container.dataset.href = response[i].url;
                          let image = document.createElement('img');
                          image.classList.add('image-picker-image');
                          image.src = response[i].url;
                          let name = document.createElement('p');
                          name.classList.add('image-picker-name');
                          name.innerText = response[i].name;
                          name.title = response[i].name;
                          container.append(image);
                          container.append(name);
                          modalContent.append(container);
                      }
                      $('.image_picker_modal-body').html(modalContent);

                      let containers = document.querySelectorAll('.image-picker-item');
                      if(containers){
                        for (let i=0;i<containers.length;i++){
                            containers[i].addEventListener('click', function(e){
                                selected(this,this.dataset.href,selectedItems);
                            },false);
                          }
                      }
                      
                      // Display Modal
                      $('#image_picker_modal').modal('show'); 
                    }
                });
                
                $('#image_picker_modal').on('hidden.bs.modal', function (e) {
                    // do something...
                    let saveImages = sessionStorage.getItem('save_images');
                    let backgroundImage = sessionStorage.getItem('background_image');
                    if(saveImages != 'true'){
                        sessionStorage.removeItem('save_images');
                        sessionStorage.removeItem('selected_item');
                        sessionStorage.removeItem('background_image');
                        selectedItems = [];
                        return;
                    }
                    let selectedImages = JSON.parse(sessionStorage.getItem('selected_item'));
                    if(selectedImages && saveImages == 'true' && backgroundImage == 'false'){
                        editor.execute( 'insertImage', {
                            source: selectedImages
                        } );
                        editor.editing.view.focus();
                        
                        sessionStorage.removeItem('selected_item');
                        sessionStorage.removeItem('save_images');
                        sessionStorage.removeItem('background_image');
                        selectedItems = [];
                    }        
                    
                    // Remove the event after it's initialized once (solves problems with multiple editors on one page)
                    $('#image_picker_modal').off();        
                });

                
            } );

            return view;
        } );
    }
}
